import { Card, CardContent } from "../ui/card";

interface StatCardProps {
  isLoading?: boolean;
  title: string;
  mainValue: string;
  bottomContent?: React.ReactNode;
}

export function StatCard({
  isLoading,
  title,
  mainValue,
  bottomContent,
}: StatCardProps) {
  return (
    <Card className="h-[162px] w-full">
      <CardContent>
        <div className="flex flex-col gap-spacing-2">
          <p className="paragraphs-Medium-Medium text-palette-text-secondary">
            {title}
          </p>
          <h3 className="h3-SemiBold text-palette-text-primary">
            {isLoading ? "Loading..." : mainValue}
          </h3>
        </div>
        {bottomContent && bottomContent}
      </CardContent>
    </Card>
  );
}
